// Navigation reference generated from the design reference `menuData` (RawHTMLDesign/layouts/*.html).
// Records page id, page uuid, slug and page name for every page. The layout navigation routes by SLUG, never by page id.
// `built`: false => the real page component does not exist yet, so menu links fall back to the 404 route.
// ui-components-from-reference flips `built` to true once the page component + route exist.

import { tk } from "../i18n/translate.js";

export const NOT_FOUND_ROUTE = "/404";

export const PAGES = [
  {
    "pageId": 73933,
    "pageUuid": "bfcffafe-d5c4-44c1-b77b-aec1348f91f7",
    "slug": "sign-in",
    "module": "user-access",
    "name": tk("Sign In"),
    "built": true
  },
  {
    "pageId": 73934,
    "pageUuid": "60f34cff-9c2f-487c-8b43-b379842afd91",
    "slug": "user-registration",
    "module": "user-access",
    "name": tk("User Registration"),
    "built": true
  },
  {
    "pageId": 73935,
    "pageUuid": "871170f5-ea3a-4be4-8539-675a8f03c50d",
    "slug": "forgot-password",
    "module": "user-access",
    "name": tk("Forgot Password"),
    "built": true
  },
  {
    "pageId": 73936,
    "pageUuid": "55733b84-d47f-482e-b2b9-d1dbfd02b092",
    "slug": "user-directory",
    "module": "access-management",
    "name": tk("User Directory"),
    "built": true
  },
  {
    "pageId": 73937,
    "pageUuid": "16442bf0-553e-4aec-8026-4b7d442f0734",
    "slug": "roles-permissions",
    "module": "access-management",
    "name": tk("Roles & Permissions"),
    "built": true
  },
  {
    "pageId": 73938,
    "pageUuid": "bd369146-20c6-4eea-8508-524a14cd3fa2",
    "slug": "property-location-registry",
    "module": "property-location-registry",
    "name": tk("Property & Location Registry"),
    "built": true
  },
  {
    "pageId": 73939,
    "pageUuid": "2ccccf18-b116-46a6-92c1-8c425ba10154",
    "slug": "room-kit-templates-stamping",
    "module": "property-location-registry",
    "name": tk("Room Kit Templates & Stamping"),
    "built": true
  },
  {
    "pageId": 73940,
    "pageUuid": "89467e20-411b-4e57-b930-d32989982422",
    "slug": "inwarding-asset-tagging",
    "module": "asset-inventory-custody",
    "name": tk("Inwarding & Asset Tagging"),
    "built": true
  },
  {
    "pageId": 73941,
    "pageUuid": "6aa59be4-81e7-4077-b741-59fb06f82766",
    "slug": "asset-custody-movements",
    "module": "asset-inventory-custody",
    "name": tk("Asset Custody & Movements"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "a0c09bc6-98b0-4e7f-a388-277b491a56af",
    "slug": "banquet-event-kits-batch-reconciliation",
    "module": "asset-inventory-custody",
    "name": tk("Banquet Event Kits & Batch Reconciliation"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "ad4e521d-699a-490e-8c64-7722c7d31364",
    "slug": "guest-loaners-overdue-tracker",
    "module": "asset-inventory-custody",
    "name": tk("Guest Loaners & Overdue Tracker"),
    "built": true
  },
  {
    "pageId": 73942,
    "pageUuid": "4bcba4c1-4ca8-4e9e-814b-13abab5fbf68",
    "slug": "physical-audit-verification",
    "module": "audits-physical-verification",
    "name": tk("Physical Audit Verification"),
    "built": true
  },
  {
    "pageId": 73943,
    "pageUuid": "feb29179-ce32-4712-a5f7-33a26934a24f",
    "slug": "audit-reconciliation-console",
    "module": "audits-physical-verification",
    "name": tk("Audit Reconciliation Console"),
    "built": true
  },
  {
    "pageId": 73944,
    "pageUuid": "52600b2e-21e9-4f7c-aed5-d410bf443398",
    "slug": "maintenance-incident-logging",
    "module": "maintenance-work-orders",
    "name": tk("Maintenance Incident Logging"),
    "built": true
  },
  {
    "pageId": 73945,
    "pageUuid": "c16f9a0f-beff-4437-8196-fd87ea50ee46",
    "slug": "work-orders-repair-management",
    "module": "maintenance-work-orders",
    "name": tk("Work Orders & Repair Management"),
    "built": true
  },
  {
    "pageId": 73946,
    "pageUuid": "5bc2bb00-eafe-438d-b800-6064711bfb26",
    "slug": "depreciation-runs-gl-schedules",
    "module": "fixed-asset-accounting",
    "name": tk("Depreciation Runs & GL Schedules"),
    "built": true
  },
  {
    "pageId": 73947,
    "pageUuid": "51a93812-0a94-4c68-ad71-0b2cdb90d482",
    "slug": "asset-disposals-write-offs",
    "module": "fixed-asset-accounting",
    "name": tk("Asset Disposals & Write-Offs"),
    "built": true
  },
  {
    "pageId": 73948,
    "pageUuid": "24ec9aa9-574e-49f1-bfe8-325a1ee583cc",
    "slug": "asset-valuation-analytics-dashboard",
    "module": "reports-analytics",
    "name": tk("Asset Valuation & Analytics Dashboard"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "a8ab4d97-0edd-4df0-9e3c-3c45d18b1cbd",
    "slug": "tag-generation-binding-console",
    "module": "tag-studio-physical-onboarding",
    "name": tk("Tag Generation & Binding Console"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "304ec856-5e1e-4cfd-9e01-3bd50f3f8ca5",
    "slug": "first-scan-walk-binding",
    "module": "tag-studio-physical-onboarding",
    "name": tk("First Scan Walk Binding"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "ea2a389b-0238-408f-9cca-2939da20e3ba",
    "slug": "stock-points-par-management",
    "module": "pooled-stock-par-management",
    "name": tk("Stock Points & Par Management"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "9457212d-8dd4-41e2-9c25-c70a7918b73c",
    "slug": "blind-counts-variance-console",
    "module": "pooled-stock-par-management",
    "name": tk("Blind Counts & Variance Console"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "fda5b8e9-5bfe-4250-a693-3b02f21be6fe",
    "slug": "master-item-catalogue",
    "module": "master-catalogue-categories",
    "name": tk("Master Item Catalogue"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "f1804d2e-8974-4b9a-bebe-6b7a9475d570",
    "slug": "account-subscription-plans",
    "module": "account-subscription-integrations",
    "name": tk("Account Subscription & Plans"),
    "built": true
  },
  {
    "pageId": null,
    "pageUuid": "e12ebf28-53ee-4a8d-9943-8025e8139dea",
    "slug": "integration-fabric-connectors",
    "module": "account-subscription-integrations",
    "name": tk("Integration Fabric Connectors"),
    "built": true
  }
];

export const MENUS = {
  "full": [
    {
      "label": tk("Administration"),
      "pageId": null,
      "icon": "fas fa-user-shield",
      "bottom": false,
      "children": [
        {
          "label": tk("User Directory"),
          "pageId": 73936,
          "icon": "fas fa-users-cog",
          "bottom": false
        },
        {
          "label": tk("Roles & Permissions"),
          "pageId": 73937,
          "icon": "fas fa-shield-alt",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Properties"),
      "pageId": null,
      "icon": "fas fa-hotel",
      "bottom": false,
      "children": [
        {
          "label": tk("Locations & Hierarchy"),
          "pageId": 73938,
          "icon": "fas fa-sitemap",
          "bottom": false
        },
        {
          "label": tk("Room Kit Stamping"),
          "pageId": 73939,
          "icon": "fas fa-cubes",
          "bottom": false
        },
        {
          "label": tk("Room Contents Sheet"),
          "pageId": 99012,
          "route": "/location-contents-sheet",
          "icon": "fas fa-clipboard-list",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Assets & Inventory"),
      "pageId": null,
      "icon": "fas fa-boxes",
      "bottom": false,
      "children": [
        {
          "label": tk("Inwarding & Tagging"),
          "pageId": 73940,
          "icon": "fas fa-barcode",
          "bottom": true
        },
        {
          "label": tk("Custody & Movements"),
          "pageId": 73941,
          "icon": "fas fa-exchange-alt",
          "bottom": false
        },
        {
          "label": tk("Asset Lookup"),
          "pageId": 99151,
          "route": "/asset-detail",
          "icon": "fas fa-search",
          "bottom": false
        },
        {
          "label": tk("Master Item Catalogue"),
          "pageId": 99006,
          "route": "/master-item-catalogue",
          "icon": "fas fa-book",
          "bottom": false
        },
        {
          "label": tk("Tag Generation & Binding"),
          "pageId": 99007,
          "route": "/tag-generation-binding-console",
          "icon": "fas fa-tags",
          "bottom": false
        },
        {
          "label": tk("First-Scan Walk"),
          "pageId": 99008,
          "route": "/first-scan-walk-binding",
          "icon": "fas fa-link",
          "bottom": false
        },
        {
          "label": tk("Stock Points & Par"),
          "pageId": 99009,
          "route": "/stock-points-par-management",
          "icon": "fas fa-layer-group",
          "bottom": false
        },
        {
          "label": tk("Linen Laundry"),
          "pageId": 99161,
          "route": "/linen-laundry",
          "icon": "fas fa-tshirt",
          "bottom": false
        },
        {
          "label": tk("Opening Inventory"),
          "pageId": 99162,
          "route": "/opening-inventory",
          "icon": "fas fa-truck-loading",
          "bottom": false
        },
        {
          "label": tk("Banquet Event Kits"),
          "pageId": 99010,
          "route": "/banquet-event-kits-batch-reconciliation",
          "icon": "fas fa-concierge-bell",
          "bottom": false
        },
        {
          "label": tk("Guest Loaners"),
          "pageId": 99011,
          "route": "/guest-loaners-overdue-tracker",
          "icon": "fas fa-hand-holding",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Field App"),
      "pageId": null,
      "icon": "fas fa-mobile-alt",
      "bottom": false,
      "children": [
        {
          "label": tk("Scan"),
          "pageId": 99701,
          "route": "/scan",
          "icon": "fas fa-qrcode",
          "bottom": true
        },
        {
          "label": tk("Asset Quick View"),
          "pageId": 99702,
          "route": "/asset-quick-view",
          "icon": "fas fa-box",
          "bottom": false
        },
        {
          "label": tk("Sync Status"),
          "pageId": 99703,
          "route": "/sync-status",
          "icon": "fas fa-sync-alt",
          "bottom": true
        }
      ]
    },
    {
      "label": tk("Audits"),
      "pageId": null,
      "icon": "fas fa-clipboard-check",
      "bottom": false,
      "children": [
        {
          "label": tk("Physical Verification"),
          "pageId": 73942,
          "route": "/physical-audit-verification",
          "icon": "fas fa-qrcode",
          "bottom": true
        },
        {
          "label": tk("Reconciliation Console"),
          "pageId": 73943,
          "route": "/audit-reconciliation-console",
          "icon": "fas fa-balance-scale",
          "bottom": false
        },
        {
          "label": tk("Exception Queue"),
          "pageId": 99154,
          "route": "/audit-exception-queue",
          "icon": "fas fa-exclamation-circle",
          "bottom": false
        },
        {
          "label": tk("Audit Schedules"),
          "pageId": 99001,
          "route": "/audit-schedules",
          "icon": "fas fa-calendar-check",
          "bottom": false
        },
        {
          "label": tk("Blind Counts & Variance"),
          "pageId": 99002,
          "route": "/blind-counts-variance-console",
          "icon": "fas fa-eye-slash",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Maintenance"),
      "pageId": null,
      "icon": "fas fa-tools",
      "bottom": false,
      "children": [
        {
          "label": tk("Incident Logging"),
          "pageId": 73944,
          "icon": "fas fa-exclamation-triangle",
          "bottom": false
        },
        {
          "label": tk("Work Orders"),
          "pageId": 73945,
          "icon": "fas fa-wrench",
          "bottom": true
        }
      ]
    },
    {
      "label": tk("Accounting"),
      "pageId": null,
      "icon": "fas fa-calculator",
      "bottom": false,
      "children": [
        {
          "label": tk("Depreciation Runs"),
          "pageId": 99003,
          "route": "/depreciation-runs-gl-schedules",
          "icon": "fas fa-file-invoice-dollar",
          "bottom": false
        },
        {
          "label": tk("Disposals & Write-Offs"),
          "pageId": 73947,
          "route": "/asset-disposals-write-offs",
          "icon": "fas fa-archive",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Account"),
      "pageId": null,
      "icon": "fas fa-credit-card",
      "bottom": false,
      "children": [
        {
          "label": tk("Plans & Billing"),
          "pageId": 99004,
          "route": "/account-subscription-plans",
          "icon": "fas fa-file-invoice",
          "bottom": false
        },
        {
          "label": tk("Integrations"),
          "pageId": 99005,
          "route": "/integration-fabric-connectors",
          "icon": "fas fa-network-wired",
          "bottom": false
        },
        {
          "label": tk("API & Webhooks"),
          "pageId": 99121,
          "route": "/developer-access",
          "icon": "fas fa-plug",
          "bottom": false
        },
        {
          "label": tk("Connected Platforms"),
          "pageId": 99122,
          "route": "/connected-platforms",
          "icon": "fas fa-project-diagram",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Dashboard"),
      "pageId": 73948,
      "route": "/asset-valuation-analytics-dashboard",
      "icon": "fas fa-chart-line",
      "bottom": true
    }
  ],
  "set5": [
    {
      "label": tk("Assets & Inventory"),
      "pageId": null,
      "icon": "fas fa-boxes",
      "bottom": false,
      "children": [
        {
          "label": tk("Inwarding & Tagging"),
          "pageId": 73940,
          "icon": "fas fa-barcode",
          "bottom": true
        },
        {
          "label": tk("Custody & Movements"),
          "pageId": 73941,
          "icon": "fas fa-exchange-alt",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Maintenance"),
      "pageId": null,
      "icon": "fas fa-tools",
      "bottom": false,
      "children": [
        {
          "label": tk("Incident Logging"),
          "pageId": 73944,
          "icon": "fas fa-exclamation-triangle",
          "bottom": false
        },
        {
          "label": tk("Work Orders"),
          "pageId": 73945,
          "icon": "fas fa-wrench",
          "bottom": true
        }
      ]
    },
    {
      "label": tk("Dashboard"),
      "pageId": 73948,
      "route": "/asset-valuation-analytics-dashboard",
      "icon": "fas fa-chart-line",
      "bottom": true
    }
  ],
  "set6": [
    {
      "label": tk("Assets & Inventory"),
      "pageId": null,
      "icon": "fas fa-boxes",
      "bottom": false,
      "children": [
        {
          "label": tk("Inwarding & Tagging"),
          "pageId": 73940,
          "icon": "fas fa-barcode",
          "bottom": true
        },
        {
          "label": tk("Custody & Movements"),
          "pageId": 73941,
          "icon": "fas fa-exchange-alt",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Audits"),
      "pageId": null,
      "icon": "fas fa-clipboard-check",
      "bottom": false,
      "children": [
        {
          "label": tk("Physical Verification"),
          "pageId": 73942,
          "route": "/physical-audit-verification",
          "icon": "fas fa-qrcode",
          "bottom": true
        },
        {
          "label": tk("Blind Counts & Variance"),
          "pageId": 99002,
          "route": "/blind-counts-variance-console",
          "icon": "fas fa-eye-slash",
          "bottom": false
        }
      ]
    },
    {
      "label": tk("Maintenance"),
      "pageId": null,
      "icon": "fas fa-tools",
      "bottom": false,
      "children": [
        {
          "label": tk("Incident Logging"),
          "pageId": 73944,
          "icon": "fas fa-exclamation-triangle",
          "bottom": false
        },
        {
          "label": tk("Work Orders"),
          "pageId": 73945,
          "icon": "fas fa-wrench",
          "bottom": true
        }
      ]
    },
    {
      "label": tk("Dashboard"),
      "pageId": 73948,
      "route": "/asset-valuation-analytics-dashboard",
      "icon": "fas fa-chart-line",
      "bottom": true
    }
  ]
};

const byId = new Map(PAGES.filter((p) => p.pageId != null).map((p) => [p.pageId, p]));
const bySlug = new Map(PAGES.map((p) => [p.slug, p]));

export const getPageById = (pageId) => byId.get(pageId);
export const getPageBySlug = (slug) => bySlug.get(slug);

/** Slug-based route for a menu entry; falls back to 404 until its page component is built. */
export function routeForPageId(pageId) {
  const page = byId.get(pageId);
  if (!page) return NOT_FOUND_ROUTE;
  return page.built ? "/" + page.slug : NOT_FOUND_ROUTE;
}

export const slugRoute = (slug) => "/" + slug;
export const DEFAULT_PAGE_ID = 73948;
